import { InjectionToken } from '@angular/core';
import { API_BASE_URL, ENVIRONMENTS } from '../constants/provider.constant';
import {
  API_BASE_URL_DEV,
  API_BASE_URL_PRODUCTION, CONSOLE_BASE_URL_DEV,
  CONSOLE_BASE_URL_PRODUCTION,
  UI_BASE_URL_DEV,
  UI_BASE_URL_PRODUCTION
} from '../constants/api.constant';
import { APIBaseURLOption } from '../interfaces/api-base-url-option.interface';

export const API_BASE_URL_TOKEN = new InjectionToken<APIBaseURLOption>(
  API_BASE_URL
);
export const apiBaseURLProvider = {
  provide: API_BASE_URL_TOKEN,
  useFactory: (env: { production: boolean }): APIBaseURLOption => {
    return {
      rootBase: env.production ? API_BASE_URL_PRODUCTION : API_BASE_URL_DEV,
      UIRootBase: env.production ? UI_BASE_URL_PRODUCTION : UI_BASE_URL_DEV,
      consoleUIRootBase: env.production ? CONSOLE_BASE_URL_PRODUCTION : CONSOLE_BASE_URL_DEV,
    };
  },
  deps: [ENVIRONMENTS],
};
